import { Controller } from "@hotwired/stimulus"

// Submits the enclosing form when the season/year <select> changes, so the screen
// re-renders for the chosen season. Replaces per-screen inline
// `onchange="...SeasonChanged(this)"` handlers.
//
// Optionally clears season-specific fields first (e.g. a teacher select whose
// options only make sense for the previous season) via:
//   data-season-picker-clear-value="#input_student_teacher, #other_field"
//
// See docs/years_and_seasons.md.
export default class extends Controller {
  static values = { clear: String }

  submit(event) {
    const form = event.target.closest("form")
    if (!form) return

    if (this.clearValue) {
      form.querySelectorAll(this.clearValue).forEach((el) => { el.value = "" })
    }

    if (typeof form.requestSubmit === "function") {
      form.requestSubmit()
    } else {
      form.submit()
    }
  }
}
